import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const PinAddress = ({ setShowPopupMap, setPayload, setPosition }) => {
    const [address, setAddress] = useState('');
    const [searchAddress, setSearchAddress] = useState('');
    const [posX, setPosX] = useState('');
    const [posY, setPosY] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [addressList, setAddressList] = useState([]);
    const mapRef = useRef(null);
    const mapInstance = useRef(null);
    const geocoder = useRef(null);
    const infowin = useRef(null);
    const infowinCur = useRef(null);
    const markerList = useRef([]);
    const markerListCust = useRef([]);
    const selectedMarker = useRef(null);

    const MARKER_WIDTH = 33;
    const MARKER_HEIGHT = 36;
    const OFFSET_X = 12;
    const OFFSET_Y = MARKER_HEIGHT;
    const OVER_MARKER_WIDTH = 40;
    const OVER_MARKER_HEIGHT = 42;
    const OVER_OFFSET_X = 13;
    const OVER_OFFSET_Y = OVER_MARKER_HEIGHT;
    const SPRITE_MARKER_URL = '/images/icons/sp_d_marker_normal_full.png';
    const SPRITE_WIDTH = 634;
    const SPRITE_HEIGHT = 936;
    const SPRITE_GAP = 10;
    const zoomLevel = 2;

    useEffect(() => {
        // Load Kakao Maps SDK
        const script = document.createElement('script');
        script.src = '//dapi.kakao.com/v2/maps/sdk.js?appkey=869ab5fe9a813cbd0afa8472d40e2c2d&libraries=services';
        script.async = true;
        document.head.appendChild(script);

        script.onload = () => {
            const kakao = window.kakao;
            geocoder.current = new kakao.maps.services.Geocoder();
            infowin.current = new kakao.maps.InfoWindow({ zIndex: 10, removable: true });
            infowinCur.current = new kakao.maps.InfoWindow({ zIndex: 10, removable: true });

            if (searchAddress) {
                getMapDataAddr();
            } else if (parseFloat(posX) > 0 && parseFloat(posY) > 0) {
                getMapDataPos(searchAddress, posX, posY);
            }

            if (mapInstance.current) {
                mapInstance.current.relayout();
            }
        };

        return () => {
            document.head.removeChild(script);
        };
        // eslint-disable-next-line
    }, []);

    const createMapNode = (posX, posY) => {
        const kakao = window.kakao;
        const mapOption = {
            level: zoomLevel,
            center: new kakao.maps.LatLng(posY, posX),
            mapTypeId: kakao.maps.MapTypeId.ROADMAP,
        };
        mapInstance.current = new kakao.maps.Map(mapRef.current, mapOption);
        const zoomControl = new kakao.maps.ZoomControl();
        mapInstance.current.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

        setTimeout(() => {
            if (mapInstance.current) {
                mapInstance.current.relayout();
                mapInstance.current.setCenter(new kakao.maps.LatLng(posY, posX));
            }
        }, 100);
    };

    const createMarkerImage = (markerSize, offset, spriteOrigin) => {
        const kakao = window.kakao;
        return new kakao.maps.MarkerImage(SPRITE_MARKER_URL, markerSize, {
            offset: offset,
            spriteOrigin: spriteOrigin,
            spriteSize: new kakao.maps.Size(SPRITE_WIDTH, SPRITE_HEIGHT),
        });
    };

    const addMarker = (y, x, normalOrigin, overOrigin, clickOrigin, info, sNaverAddress) => {
        const kakao = window.kakao;
        const normalImage = createMarkerImage(
            new kakao.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
            new kakao.maps.Point(OFFSET_X, OFFSET_Y),
            normalOrigin,
        );
        const overImage = createMarkerImage(
            new kakao.maps.Size(OVER_MARKER_WIDTH, OVER_MARKER_HEIGHT),
            new kakao.maps.Point(OVER_OFFSET_X, OVER_OFFSET_Y),
            overOrigin,
        );
        const clickImage = createMarkerImage(
            new kakao.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
            new kakao.maps.Point(OFFSET_X, OFFSET_Y),
            clickOrigin,
        );
        const position = new kakao.maps.LatLng(y, x);

        const marker = new kakao.maps.Marker({
            map: mapInstance.current,
            position: position,
            image: normalImage,
        });
        marker.normalImage = normalImage;
        markerList.current.push(marker);

        const overHandler = () => {
            if (!selectedMarker.current || selectedMarker.current !== marker) {
                marker.setImage(overImage);
            }
            infowin.current.setContent(info);
            infowin.current.open(mapInstance.current, marker);
        };

        const outHandler = () => {
            if (!selectedMarker.current || selectedMarker.current !== marker) {
                marker.setImage(normalImage);
            }
            infowin.current.close();
        };

        const clickHandler = () => {
            if (!selectedMarker.current || selectedMarker.current !== marker) {
                if (selectedMarker.current) {
                    selectedMarker.current.setImage(selectedMarker.current.normalImage);
                }
                marker.setImage(clickImage);
            }
            selectedMarker.current = marker;
            mapInstance.current.setCenter(marker.getPosition());
            infowin.current.setContent(info);
            infowin.current.open(mapInstance.current, marker);
            setPosStr(sNaverAddress, marker.getPosition().getLng(), marker.getPosition().getLat());
        };

        kakao.maps.event.addListener(marker, 'mouseover', overHandler);
        kakao.maps.event.addListener(marker, 'mouseout', outHandler);
        kakao.maps.event.addListener(marker, 'click', clickHandler);
    };

    const getMapDataAddr = (query) => {
        const kakao = window.kakao;
        geocoder.current.addressSearch(query, (result, status) => {
            if (status === kakao.maps.services.Status.OK) {
                createMapNode(result[0].x, result[0].y);

                kakao.maps.event.addListener(mapInstance.current, 'click', (mouseEvent) => {
                    if (window.confirm('해당위치에 마커를 추가하시겠습니까?')) {
                        searchCoordToAddress(mouseEvent);
                    }
                });

                const addrList = [];
                result.forEach((item, i) => {
                    const k = i >= 10 ? 0 : i;
                    const kk = k * (MARKER_HEIGHT + SPRITE_GAP);
                    const roadType = item.address_type.includes('ROAD') ? '[도로명]' : '[지번]';
                    const naverAddress = item.address_name;
                    const xPos = item.x;
                    const yPos = item.y;

                    const gapX = MARKER_WIDTH + SPRITE_GAP;
                    const originY = (MARKER_HEIGHT + SPRITE_GAP) * i;
                    const overOriginY = (OVER_MARKER_HEIGHT + SPRITE_GAP) * i;
                    const normalOrigin = new kakao.maps.Point(0, originY);
                    const clickOrigin = new kakao.maps.Point(gapX * 2, originY);
                    const overOrigin = new kakao.maps.Point(gapX * 6, overOriginY);

                    const infoContent = `<div style="padding:5px;"><div style="margin-right:20px;">${roadType}${naverAddress}</div><br>위도:${yPos}<br>경도:${xPos}</div>`;
                    addMarker(yPos, xPos, normalOrigin, overOrigin, clickOrigin, infoContent, naverAddress);

                    addrList.push({
                        xPos,
                        yPos,
                        roadType,
                        naverAddress,
                        k,
                        style: { backgroundImage: `url('${SPRITE_MARKER_URL}')`, backgroundPosition: `0px ${-kk}px` },
                    });
                });

                addrList.push({
                    xPos: '',
                    yPos: '',
                    roadType: '',
                    naverAddress: '[사용자지정]',
                    k: '',
                    style: { backgroundImage: `url('${SPRITE_MARKER_URL}')`, backgroundPosition: '-129px 0px' },
                    isCustom: true,
                });

                setAddressList(addrList);
            } else {
                setAddressList([
                    { naverAddress: '<font color="red">※ 검색된 위치정보가 없습니다.</font>', isError: true },
                ]);
                alert(`${query}의 검색 결과가 없거나 기타 네트워크 에러가 발생했습니다.`);
            }
        });
    };

    const getMapDataPos = (addr, posX, posY) => {
        const kakao = window.kakao;
        const gapX = MARKER_WIDTH + SPRITE_GAP;
        const normalOrigin = new kakao.maps.Point(0, 0);
        const clickOrigin = new kakao.maps.Point(gapX * 2, 0);
        const normalImage = createMarkerImage(
            new kakao.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
            new kakao.maps.Point(OFFSET_X, OFFSET_Y),
            normalOrigin,
        );
        const clickImage = createMarkerImage(
            new kakao.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
            new kakao.maps.Point(OFFSET_X, OFFSET_Y),
            clickOrigin,
        );
        const latlng = new kakao.maps.LatLng(posY, posX);

        geocoder.current.coord2Address(posX, posY, (result, status) => {
            if (status === kakao.maps.services.Status.OK) {
                createMapNode(posX, posY);

                kakao.maps.event.addListener(mapInstance.current, 'click', (mouseEvent) => {
                    if (window.confirm('해당위치에 마커를 추가하시겠습니까?')) {
                        searchCoordToAddress(mouseEvent);
                    }
                });

                const roadType = result[0].road_address ? '[도로명]' : '[지번]';
                const detailAddr = result[0].road_address
                    ? `<div style="margin-right:20px;">[도로명]${result[0].road_address.address_name}</div>`
                    : '';
                const addrContent = `${detailAddr}<div style="margin-right:20px;">[지번]${result[0].address.address_name}</div>`;
                const content = `<div class="bAddr">${addrContent}<br>위도:${latlng.getLat()}<br>경도:${latlng.getLng()}</div>`;
                const dspAddr = result[0].road_address
                    ? result[0].road_address.address_name
                    : result[0].address.address_name;

                const marker = new kakao.maps.Marker({
                    map: mapInstance.current,
                    position: latlng,
                    image: normalImage,
                });
                marker.setPosition(latlng);
                marker.setMap(mapInstance.current);
                mapInstance.current.setCenter(latlng);
                markerList.current.push(marker);

                infowin.current.setContent(content);
                infowin.current.open(mapInstance.current, marker);
                setPosStr(dspAddr, posX, posY);

                const outHandler = () => {
                    if (!selectedMarker.current || selectedMarker.current !== marker) {
                        marker.setImage(normalImage);
                    }
                    infowin.current.close();
                };

                const clickHandler = () => {
                    if (!selectedMarker.current || selectedMarker.current !== marker) {
                        if (selectedMarker.current) {
                            selectedMarker.current.setImage(selectedMarker.current.normalImage);
                        }
                        marker.setImage(clickImage);
                    }
                    selectedMarker.current = marker;
                    mapInstance.current.setCenter(marker.getPosition());
                    infowin.current.setContent(content);
                    infowin.current.open(mapInstance.current, marker);
                    setPosStr(dspAddr, marker.getPosition().getLng(), marker.getPosition().getLat());
                };

                kakao.maps.event.addListener(marker, 'mouseout', outHandler);
                kakao.maps.event.addListener(marker, 'click', clickHandler);

                setAddressList([
                    {
                        xPos: posX,
                        yPos: posY,
                        roadType,
                        naverAddress: dspAddr,
                        k: 0,
                        style: { backgroundImage: `url('${SPRITE_MARKER_URL}')`, backgroundPosition: '0px 0px' },
                    },
                    {
                        xPos: '',
                        yPos: '',
                        roadType: '',
                        naverAddress: '[사용자지정]',
                        k: '',
                        style: { backgroundImage: `url('${SPRITE_MARKER_URL}')`, backgroundPosition: '-129px 0px' },
                        isCustom: true,
                    },
                ]);
            } else {
                setAddressList([
                    { naverAddress: '<font color="red">※ 검색된 위치정보가 없습니다.</font>', isError: true },
                ]);
            }
        });
    };

    const searchCoordToAddress = (mouseEvent) => {
        const kakao = window.kakao;
        markerListCust.current.forEach((marker) => marker.setMap(null));
        infowinCur.current.close();

        const gapX = MARKER_WIDTH + SPRITE_GAP;
        const normalOrigin = new kakao.maps.Point(gapX * 3, 0);
        const normalImage = createMarkerImage(
            new kakao.maps.Size(MARKER_WIDTH, MARKER_HEIGHT),
            new kakao.maps.Point(OFFSET_X, OFFSET_Y),
            normalOrigin,
        );
        const latlng = mouseEvent.latLng;

        const markerCur = new kakao.maps.Marker({
            map: mapInstance.current,
            position: latlng,
            image: normalImage,
        });

        geocoder.current.coord2Address(latlng.getLng(), latlng.getLat(), (result, status) => {
            if (status === kakao.maps.services.Status.OK) {
                const detailAddr = result[0].road_address
                    ? `<div style="margin-right:20px;">[도로명]${result[0].road_address.address_name}</div>`
                    : '';
                const addrContent = `${detailAddr}<div style="margin-right:20px;">[지번]${result[0].address.address_name}</div>`;
                const content = `<div class="bAddr">${addrContent}<br>위도:${latlng.getLat()}<br>경도:${latlng.getLng()}</div>`;
                const addr = result[0].road_address
                    ? result[0].road_address.address_name
                    : result[0].address.address_name;

                markerCur.setPosition(latlng);
                markerCur.setMap(mapInstance.current);
                mapInstance.current.setCenter(latlng);

                markerListCust.current = [markerCur];
                infowinCur.current.setContent(content);
                infowinCur.current.open(mapInstance.current, markerCur);

                setPosStr(addr, latlng.getLng(), latlng.getLat());

                kakao.maps.event.addListener(markerCur, 'click', () => {
                    mapInstance.current.setCenter(markerCur.getPosition());
                    markerCur.setZIndex(100);
                    infowinCur.current.open(mapInstance.current, markerCur);
                    setPosStr(addr, markerCur.getPosition().getLng(), markerCur.getPosition().getLat());
                });
            } else {
                alert('검색 결과가 없거나 기타 네트워크 에러가 발생했습니다.');
            }
        });
    };

    const setPosStr = (addr, xPos, yPos) => {
        setPosX(xPos);
        setPosY(yPos);
        setCurrentAddress(addr);
    };

    const searchPosition = (inputAddress) => {
        const query = inputAddress.trim();
        if (query) {
            setSearchAddress(query.replace('^', ' '));
            setAddressList([]);
            setPosStr('', '', '');
            getMapDataAddr(query);
        } else {
            alert('검색하실 주소를 입력해 주세요.');
        }
    };

    const setPos = (xPos, yPos, roadType, addr, k) => {
        const kakao = window.kakao;
        const position = new kakao.maps.LatLng(yPos, xPos);
        mapInstance.current.setCenter(position);
        mapInstance.current.setLevel(zoomLevel);

        markerList.current.forEach((marker, i) => {
            if (i === parseInt(k)) {
                marker.setZIndex(99);
                kakao.maps.event.trigger(marker, 'click', '');
            } else {
                marker.setZIndex(10);
            }
        });

        setPosStr(addr, xPos, yPos);
    };

    const handleSave = () => {
        if (String(posX).trim() && String(posY).trim()) {
            setPosition({
                lat: posY,
                lng: posX,
            });
            setPayload((prev) => ({
                ...prev,
                pointY: posY,
                pointX: posX,
                mapStr: currentAddress,
            }));
            setShowPopupMap(false);
        } else {
            alert('선택된 위치정보가 없습니다');
        }
    };

    return (
        <div className="pinMap modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg" style={{ maxWidth: '800px' }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">상세지도서비스 설정</h5>
                        <button type="button" className="btn-close" onClick={() => setShowPopupMap(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <label>주소입력 :</label>
                                <div className="d-flex align-items-center">
                                    <input
                                        type="text"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        onKeyPress={(e) => e.key === 'Enter' && searchPosition(e.target.value)}
                                        className="dntInf__input"
                                        placeholder="주소를 입력하세요"
                                    />
                                    <button onClick={() => searchPosition(address)} className="rsm-mng__btn">
                                        조회
                                    </button>
                                </div>
                            </div>
                            {/* <div className="row mb-2">
                                <label>검색주소 :</label>
                                <div>
                                    <span className="fw-bold">{searchAddress}</span>
                                </div>
                            </div> */}
                            <p className="text-muted small">
                                ※ 검색하고자하는 주소를 번지까지 입력해 주세요. 위치안내 서비스는 상호명이 아닌 주소로
                                위치정보를 검색합니다.
                            </p>
                        </div>
                        <hr />
                        <div className={`pin-results ${addressList && addressList.length > 0 ? 'active' : ''}`}>
                            <div className="fw-bold small mb-2">입력하신 주소로 검색된 위치정보입니다.</div>
                            <div className="row">
                                <div className="col-5" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                    {addressList.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`d-flex align-items-center mb-2 ${item.isCustom ? 'mt-3' : ''}`}
                                        >
                                            {!item.isError && (
                                                <div
                                                    className="me-2"
                                                    style={{ width: '33px', height: '36px', ...item.style }}
                                                ></div>
                                            )}
                                            {item.isError ? (
                                                <span dangerouslySetInnerHTML={{ __html: item.naverAddress }} />
                                            ) : (
                                                <Link
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!item.isCustom) {
                                                            setPos(
                                                                item.xPos,
                                                                item.yPos,
                                                                item.roadType,
                                                                item.naverAddress,
                                                                item.k,
                                                            );
                                                        }
                                                    }}
                                                    className="text-select"
                                                >
                                                    {item.isCustom ? (
                                                        <>
                                                            {item.naverAddress}
                                                            <br />
                                                            <span className="small">
                                                                지도상의 원하는 위치를 클릭하세요
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {item.roadType}
                                                            <br />
                                                            {item.naverAddress}
                                                        </>
                                                    )}
                                                </Link>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <div className="col-7">
                                    <div
                                        id="RecMap"
                                        ref={mapRef}
                                        style={{ width: '100%', height: '400px', border: '1px solid black' }}
                                    ></div>
                                </div>
                            </div>
                            <div>
                                <p>
                                    선택주소 : <span>{currentAddress}</span>
                                </p>
                                <p>
                                    위도 : <span>{posY}</span> &nbsp; 경도 : <span>{posX}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="resume__btn" onClick={() => setShowPopupMap(false)}>
                            닫기
                        </button>
                        <button type="button" className="resume__btn resume__btn--blue" onClick={handleSave}>
                            위치정보 저장
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PinAddress;
